import React from 'react'

import { ProgressGraph } from './styles'

interface IPercentageProps {
  percentage: number
  size?: 'mini' | 'small' | 'large' | 'medium'
  percentage_fill?: string

  className?: string

  svgProps?: React.SVGProps<SVGSVGElement>
}

const ProgressCircle: React.FC<IPercentageProps> = ({
  percentage,
  size,
  percentage_fill,
  className,
  svgProps,
}) => {
  return (
    <ProgressGraph size={size} percentage_fill={percentage_fill} className={className}>
      <svg viewBox="0 0 36 36" className="circular-chart" {...svgProps}>
        <path
          className="circle-bg"
          d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="circle"
          strokeDasharray={`${percentage}, 100`}
          d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <text x="18" y="20.35" className="percentage">
          {percentage}%
        </text>
      </svg>
    </ProgressGraph>
  )
}

export default ProgressCircle
